import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Authorization from '../../services/Auth.api.service';
import {useAuth} from '@dofleini/security';
import PageLayout from '../../components/PageLayout';
import {useTranslation} from 'react-i18next';
import {Button, message} from 'antd';
import RecoverPasswordForm from '../Recovery/RecoverPasswordForm';
import {Link} from 'react-router-dom';

const pageInfo = {
  default: {
    title: 'confirmation.successTitle',
    subtext: 'confirmation.successSubtext',
  },
  loading: {
    title: 'confirmation.loading',
    subtext: '',
  },
  sent: {
    title: 'confirmation.newTitle',
    subtext: 'recovery.newSentSubtext',
  },

  error: {
    title: 'confirmation.errorCheckTitle',
    titleProps: {className: 'text-error'},
    subtext: 'confirmation.errorCheckSubtext',
  }
};

function EmailConfirmation(props) {
  const {t} = useTranslation('authentication');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [errorCheck, setCheckError] = useState(false);
  const [sent, setSent] = useState(false);
  const {reload} = useAuth();

  useEffect(() => {
    Authorization.checkConfirmationAccess(props.match.params.key).then(res => {
      setLoading(false);
      setCheckError(false);
      Authorization.service.setToken(res.accessToken, true);
      if (res.space)
        Authorization.service.setSpace(res.space);
      setTimeout(() => {
        reload();
      }, 2000);
    }).catch(() => {
      setLoading(false);
      setCheckError(true);
    });
  }, [props.match.params.key, reload]);

  const handleSubmit = useCallback((formData) => {
    setLoading(true);
    Authorization.resendConfirmationAccess(formData).then(() => {
      setLoading(false);
      message.success(t('signup.resendSuccess'));
      setSent(formData.identifier);
    }).catch((err) => {
      setLoading(false);
      const notFound = err?.response?.data?.message === 'User not found or The user is already verified' ? 'confirmation.notfound' : '';
      setError(notFound || (err && (err.status === 401 ? 'signup.badCredentials' : !err.status ? 'login.network' : 'login.generalError')));
    });
  }, [t]);

  let pageProps = errorCheck ? pageInfo.error : pageInfo.default;
  let content = errorCheck ?
    <RecoverPasswordForm label={t('confirmation.newLink')} action={t('confirmation.action')} onSent={handleSubmit}
      loading={loading}/> : '';

  if (sent) {
    content = '';
    pageProps = pageInfo.sent;
  }

  return (
    <PageLayout {...pageProps} error={error}>
      {content}
      {!errorCheck &&
      <div>
        <Link to={'/'}>
          <Button size={'large'} type={'primary'} className={'w-full'}>
            {t('letsStart')}
          </Button>
        </Link>
      </div>}
    </PageLayout>
  );
}

export default EmailConfirmation;

EmailConfirmation.propTypes = {
  match: PropTypes.any
};
